import { BarChart, Palette, Sparkles, TrendingUp } from "lucide-react";
import { getPersonaByValue } from "./personas";
import test_00 from "../../../test/test_00_coverage.md?raw";
import test_01 from "../../../test/test_01_beauty_tracker_request.md?raw";
import test_05 from "../../../test/test_05_tiktok_request.md?raw";
import test_06 from "../../../test/test_06_multisource_request.md?raw";
import test_07 from "../../../test/test_07_persona.md?raw";

export const samplePrompts = [
  {
    icon: TrendingUp,
    label: "Instagram beauty tracker",
    fullPrompt: test_01,
    primary: true,
  },
  {
    icon: Sparkles,
    label: "Hair on TikTok",
    fullPrompt: test_05,
    primary: true,
  },
  {
    icon: Palette,
    label: "Multi-platform hair",
    fullPrompt: test_06,
    primary: true,
  },
  {
    icon: BarChart,
    label: "Full coverage analysis",
    fullPrompt: test_00,
    primary: false,
  },
  {
    icon: TrendingUp,
    label: "Concise Instagram beauty tracker",
    fullPrompt: test_07,
    persona: getPersonaByValue("Executive"),
    primary: false,
  },
];
